import { AlightCustomSettingsType, AlightCustomSettings } from '../../settings/alight-custom-settings';
//import reducer from './reducers';
//@ts-ignore
import watch from 'redux-watch'
import * as Actions from './actions/actions';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import {Reducer, Store} from "redux";
import {Message} from "@alme/ui-web/types/response";
import {AlmeResponseV5} from "@alme/types/response/AlmeResponse";
import {HistoryMessageError} from "@alme/ui-web/types/history";


export default class ChatBubbleHistoryAppender
{

    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(passedSettings: AlightCustomSettingsType = AlightCustomSettings)
    {
        this._settings = passedSettings;
    }

    static getDefaultSettings(): AlightCustomSettingsType
    {
        return AlightCustomSettings;
    }


    initialize(store: Store<AlmeState>): void
    {
        this._store = store;

        const { Base, processedResponse } = this._settings.stateLocations.Conversation;

        const sentInputWatcher = watch(this._store.getState.bind(this), `${Base}.${processedResponse}`);
        const processedResponseWatcher = watch(this._store.getState.bind(this), `${Base}.${processedResponse}`);
        const processedErrorWatcher = watch(this._store.getState.bind(this), `${Base}.${processedResponse}`);

        this._store.subscribe(processedResponseWatcher((newVal: Message) => this.appendProcessedResponseToHistory(newVal)));
        this._store.subscribe(processedErrorWatcher((newVal: Message) => this.appendErrorToHistory(newVal)));
    }

    //#endregion



    //#region History Methods


    appendErrorToHistory(message?: Message): void
    {
        if (!message?.error)
        {
            return;
        }
    }

    appendProcessedResponseToHistory(message?: Message): void
    {
        if (!this.doesPersistToHistory(message) || !(message?.response as AlmeResponseV5).text)
        {
            return;
        }

        const { responseRevision, text, navUrl, displayLinkCollection, responseActions, extensionData } = message?.response as AlmeResponseV5;

        const historyMessage = {
            type: this._settings.messageConstants.advocacyProactiveResponse,
            responseRevision,
            text,
            navUrl,
            displayLinkCollection,
            responseActions,
            extensionData,
        };

        this._store?.dispatch(Actions.appendReceivedResponse(historyMessage, this._settings.stateLocations.History.Messages));
    }



    //#endregion



    //#region Helper Methods

    doesPersistToHistory(message?: Message): boolean
    {
        return message?.messageType === this._settings.messageConstants.advocacyProactiveResponse;
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./modules/advocacy-chat-bubble/chat-bubble-history-appender.ts